import React from "react";

export default function DynamicAboutSection({ data, onAction }) {
  return (
    <section className="dynamic-about-section" aria-labelledby="dynamic-about-title">
      <div className="container">
        <div className="row align-items-center justify-content-center dynamic-header-row">
          <div className="col-lg-8">
            <div className="dynamic-about-content text-center">
              <span className="main-title">{data.eyebrow}</span>
              <h2 id="dynamic-about-title" className="heading text-center">{data.title}</h2>
              <p className="dynamic-about-description text-center">{data.description}</p>

            </div>
          </div>
        </div>
      </div>
      {data.marqueeItems?.length > 0 && (
        <div className="dynamic-about-marquee" tabIndex={0} aria-label="Team skills; pause scrolling by hovering or focusing">
          <div className="dynamic-about-marquee-band">
            <div className="dynamic-about-marquee-track">
              {[0, 1].map((copy) => (
                <ul className="dynamic-about-marquee-list" key={copy} aria-hidden={copy === 1 ? true : undefined}>
                  {data.marqueeItems.map((item, index) => (
                    <li key={`${item}-${index}`}>
                      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
                        <path d="M12 0C14 0 13 8 24 12C24 14 16 13 12 24C10 24 11 16 0 12C0 10 8 11 12 0Z" fill="currentColor" />
                      </svg>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
